export const MISSING_TOKEN = 'missing_token';
export const GET_AIRPORT = 'get_airport';
export const GET_AIRPORT_SUCESS = 'get_airport_sucess';
export const GET_AIRPORT_FAIL = 'get_airport_fail';

export const FIND_ITINERARIES = 'find_itineraries';
export const FIND_ITINERARIES_SUCCESS = 'find_itineraries_success';
export const FIND_ITINERARIES_FAIL = 'find_itineraries_fail';
export const SELECT_ITINERARY_OPTION = 'select_itinerary_option';
export const GET_ITINERARIES_NETWORK = 'get_itineraries_network';
export const GET_ITINERARIES_NETWORK_SUCCESS = 'get_itineraries_network_success';
export const GET_ITINERARIES_NETWORK_FAIL = 'get_itineraries_network_fail';
export const CHANGE_ITINERARIES_DAY = 'change_itineraries_day';
export const CHANGE_STOP_OPTION = 'change_stop_option';

export const TOGGLE_ROUTE_OPTIONS = 'toggle_route_options';

export const CLICK_FROM = 'click_from';
export const CLICK_TO = 'click_to';
export const CLICK_MAP = 'click_map';
export const CHANGE_FROM = 'change_from';
export const CHANGE_TO = 'chage_to';
export const SHOW_ALERT = 'show_alert';
export const CLOSE_ALERT = 'close_alert';
export const CLOSE_ROUTE = 'close_route';
export const SET_DEPARTURE = 'set_departure';
export const SET_ARRIVAL = 'set_arrival';
export const CLICK_MARKER = 'click_marker';
export const FIND_ALL_ROUTES = 'find_all_routes';
export const FIND_ALL_ROUTES_SUCESS = 'find_all_routes_sucess';
export const FIND_ALL_ROUTES_FAIL = 'find_all_routes_fail';
export const CLOSE_ALL_ROUTES = 'close_all_routes';
export const GET_REGION = 'get_region';
export const GET_REGION_SUCESS = 'get_region_sucess';
export const GET_REGION_FAIL = 'get_region_fail';

export const TOGGLE_CODESHARE_CHECK = 'toggle_codeshare_check';

export const GET_ROUTE_PRICE = 'get_route_price';
export const GET_ROUTE_PRICE_SUCCESS = 'get_route_price_success';
export const GET_ROUTE_PRICE_FAILED = 'get_route_price_failed';
export const SHOW_ROUTE_PRICE = 'show_route_price';
export const HIDE_ROUTE_PRICE = 'hide_route_price';